// @ts-ignore
const pdfjs = window.pdfjsLib;
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export const pdf = pdfjs;
